import Input from "../../../common/Input";

const Compliances = ({
	handleChange,
	values,
	setFieldTouched,
	touched,
	errors,
	isEdit,
	handleEditIconClick,
	handleBlur,
	editingField,
	isDisabled,
}) => {
	// const { handleChange, values, setFieldTouched, touched, errors } = formik;

	return (
		<div className="mb-3">
			<h2 className="text-black-lose text-[13px] font-medium mb-2">
				Compliances
			</h2>
			<div className="grid grid-cols-12 gap-[8px]">
				<div className="col-span-4">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="GSTN"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="compliances.gstin"
						id="compliances.gstin"
						value={values.compliances.gstin}
						onChange={(e) => {
							handleChange(e);
							setFieldTouched("compliances.gstin", true, false);
						}}
						disabled={isDisabled && editingField !== "compliances.gstin"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("compliances.gstin") : "")}
						onEditClick={() => handleEditIconClick("compliances.gstin")}
						disabledClass="bg-primary-50 border-primary-50 "
						// isError={
						//   touched?.compliances?.gstin && Boolean(errors?.compliances?.gstin)
						// }
						// errorMessage={errors?.compliances?.gstin}
					/>
				</div>
				<div className="col-span-4">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="DLN"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="compliances.dln"
						id="compliances.dln"
						value={values.compliances.dln}
						onChange={handleChange}
						disabled={isDisabled && editingField !== "compliances.dln"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("compliances.dln") : "")}
						onEditClick={() => handleEditIconClick("compliances.dln")}
						disabledClass="bg-primary-50 border-primary-50 "
					/>
				</div>
				<div className="col-span-4">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="Fssai No."
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="compliances.fssaiNo"
						id="compliances.fssaiNo"
						value={values.compliances.fssaiNo}
						onChange={handleChange}
						disabled={isDisabled && editingField !== "compliances.fssaiNo"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("compliances.fssaiNo") : "")}
						onEditClick={() => handleEditIconClick("compliances.fssaiNo")}
						disabledClass="bg-primary-50 border-primary-50 "
					/>
				</div>
			</div>
		</div>
	);
};

export default Compliances;
